import { render, staticRenderFns } from "./ChatOptionMenu.vue?vue&type=template&id=3b6c6a56&scoped=true&"
import script from "./ChatOptionMenu.vue?vue&type=script&lang=js&"
export * from "./ChatOptionMenu.vue?vue&type=script&lang=js&"
import style0 from "./ChatOptionMenu.vue?vue&type=style&index=0&id=3b6c6a56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c6a56",
  null
  
)

export default component.exports